import { Component, DOCUMENT, inject, input, InputSignal } from '@angular/core';
import { DatePipe, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-wartung',
  imports: [NgOptimizedImage, DatePipe],
  templateUrl: './wartung.component.html',
  styleUrl: './wartung.component.scss'
})
export class WartungComponent {
  private readonly document: Document = inject(DOCUMENT);

  public wartungStart: InputSignal<Date> = input.required<Date>();
  public wartungEnde: InputSignal<Date> = input.required<Date>();
  public showZurStartseiteButton: InputSignal<boolean> = input(true);

  public zurStartseite(): void {
    this.document.location.assign('https://portal.taures.de/');
  }
}
